import { h } from "omi";

import { IconProps } from "@/components";

export function LearningNextWorkIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 24 24">
      <path
        d="M1.59998 21h4.2V3h-4.2v18Zm7.87272 0h4.2V3h-4.2v18ZM18.4 21l4.2-1.665-5-15.345-3.9273 1.485L18.4 21Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </svg>
  );
}
